import { ATTENDANCE_WINDOW_HOURS_BEFORE_START, isWithinAttendanceWindow } from '@airreading/common';
import { Temporal } from 'temporal-polyfill';

export function startSessionDisabledTooltip(
  startInstant: Temporal.Instant,
  endInstant: Temporal.Instant,
): string | undefined {
  if (isWithinAttendanceWindow(startInstant, endInstant)) {
    return undefined;
  }

  return Temporal.Instant.compare(Temporal.Now.instant(), startInstant) < 0
    ? `Classes can be started up to ${ATTENDANCE_WINDOW_HOURS_BEFORE_START} hours before the scheduled time`
    : 'Past sessions can no longer be started';
}
